export default __webpack_public_path__ + "static/media/location.0ae86363.svg";